module.exports = __webpack_public_path__ + "img/Thor_01.804e69f2.png";